import ReputableStore from "../../components/credits/ReputableStore";
/**

ReputableStorePage

صفحه نمایش فروشگاه‌های معتبر.

@component

@returns JSX.Element
*/
const ReputableStorePage = () => {
  return (
    <div>
      <ReputableStore />
    </div>
  );
};

export default ReputableStorePage;
